import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { isEmpty } from 'lodash';
import ChevronDownIcon from '../Icon/ChevronDownIcon';
import ChevronUpIcon from '../Icon/ChevronUpIcon';
import TruncateText from '../TruncateText';
const Item = ({ label, value }) => {
    return !isEmpty(value) ? (_jsxs("li", { className: "flex text-xs leading-5 justify-between", children: [_jsx("span", { className: "text-default font-medium", children: label }), _jsx("span", { className: "text-gray-500 pl-8 w-2/3 break-all text-right", children: _jsx(TruncateText, { text: value, enableCopy: true, startChars: 0, endChars: 999 }) })] })) : null;
};
const NestedObjectViewer = ({ data }) => {
    return (_jsx("ul", { className: "space-y-1.5", children: Object.entries(data).map(([key, value]) => (_jsx(NestedItem, { itemKey: key, value: value }, key))) }));
};
const NestedItem = ({ itemKey, value }) => {
    const [expanded, setExpanded] = useState(false);
    function formatKey(key) {
        return key
            .replace(/_/g, ' ')
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/\b\w/g, (char) => char.toUpperCase());
    }
    if (Array.isArray(value) && !isEmpty(value)) {
        return _jsx(Item, { label: formatKey(itemKey), value: value.join(', ') });
    }
    // toggle nested object
    if (value && typeof value === 'object' && !isEmpty(value)) {
        return (_jsxs("li", { children: [_jsxs("span", { className: "flex items-center text-default text-xs cursor-pointer font-medium hover:text-gray-700", onClick: () => setExpanded(!expanded), children: [formatKey(itemKey), ' ', expanded ? (_jsx(ChevronUpIcon, { width: "17", height: "17" })) : (_jsx(ChevronDownIcon, { width: "17", height: "17" }))] }), expanded && (_jsx("ul", { className: "pl-3 space-y-1", children: Object.entries(value).map(([subKey, subVal]) => (_jsx(NestedItem, { itemKey: subKey, value: subVal }, subKey))) }))] }));
    }
    return _jsx(Item, { label: formatKey(itemKey), value: String(value) });
};
export default NestedObjectViewer;
